<div class="header-bar"><h1>Areas</h1></div>
<div class="content-container">
  <p-table
    selectionMode="single"
    [value]="page.items"
    [lazy]="true"
    [rows]="10"
    [responsive]="true"
    [paginator]="true"
    rowHover="true"
    resizableColumns="true"
    [totalRecords]="page.total"
    (onLazyLoad)="onGridLazyLoad($event)"
    (onRowSelect)="onRowSelect($event)"
    [(selection)]="selectedItem"
    *ngIf="isLoaded; else loading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">Area Name</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr (dblclick)="onRowDblclick(item)" [pSelectableRow]="item">
        <td>{{ item.name }}</td>
      </tr>
    </ng-template>
  </p-table>

  <!--- DATATABLE DEPRECATED ---
  <p-dataTabl selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true"
               [paginator]="true" rowHover="true" resizableColumns="true"
               [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowSelect)="onRowSelect($event)"
               (onRowDblclick)="onRowDblclick($event)"
               [(selection)]="selectedItem" *ngIf="isLoaded; else loading">

    <p-column field="name" header="Area Name" [filter]="true" filterPlaceholder="Search contains"
              filterMatchMode="contains" [sortable]="tru" [editable]="false" [style]="{'width': '45%'}"></p-column>
  </p-dataTable>
  --->

  <div class="footerPanel ui-grid-row">
    <button
      type="button"
      class="btn-to-right"
      pButton
      icon="fa ui-icon-add"
      (click)="showDialogToAdd()"
      label="Add"
    ></button>

    <button
      type="button"
      class="btn-to-right"
      pButton
      (click)="onEdit()"
      label="Edit"
      icon="fa ui-icon-mode-edit"
      [disabled]="!selectedItem"
    ></button>

    <button
      type="button"
      class="btn-to-right ui-button-danger"
      pButton
      icon="fa fa-trash"
      *ngIf="selectedItem != null"
      (click)="deleteArea()"
      label="Delete"
    ></button>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>

<p-dialog
  header="Area"
  [(visible)]="displayDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <form [formGroup]="newEAreaForm" (ngSubmit)="save()" autocomplete="off">
    <input type="hidden" name="id" formControlName="id" />
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="name">Name</label></div>
        <div class="ui-g-8"><input pInputText id="name" formControlName="name" /></div>
      </div>
    </div>
    <div style="float: right">
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        class="ui-button-tertiary"
        (click)="close()"
      ></button>
      <button
        type="submit"
        class="ui-button-primary"
        pButton
        icon="fa ui-icon-check"
        label="Save"
        [disabled]="newEAreaForm.invalid"
      ></button>
    </div>
  </form>
</p-dialog>
